import { render, staticRenderFns } from "./SpkList.vue?vue&type=template&id=69ed66e1&"
import script from "./SpkList.vue?vue&type=script&lang=js&"
export * from "./SpkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports